const PARTNERGRADE = ["Authorized","Silver","Gold","Platinum","Distributor"];

let partnerGradeList = [];
for(let i in  PARTNERGRADE)
    partnerGradeList.push({ID:i,Name: PARTNERGRADE[i]});

export {  PARTNERGRADE,partnerGradeList};